export default "__VITE_ASSET__CVWzPUOJ__"